export default (vm, e) => {
  if(e.response.data['statusCode'] === 422) {
    vm.$bvToast.toast(e.response.data.message.map(item => item.message).join('\n'), {
      title: e.message,
      variant: 'danger',
      solid: true
    })
  } else if(e.response.data['statusCode'] === 404 || e.response.data['statusCode'] === 409) {
    vm.$bvToast.toast(e.response.data.message, {
      title: e.message,
      variant: 'danger',
      solid: true
    })
  } else if(e.response.data['statusCode'] === 403 ) {
    vm.$bvToast.toast(e.response.data.error, {
      title: e.response.data.error,
      variant: 'danger',
      solid: true
    })
  } else {
    vm.$bvToast.toast(JSON.stringify(e), {
      title: "error",
      variant: 'danger',
      solid: true
    })
  }
}
